import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';
import arrow from 'assets/icons/next.svg';
import complete from 'assets/icons/complete-status.svg';
import incomplete from 'assets/icons/incomplete-icon.svg';
import completeAr from 'assets/icons/complete-status_ar.svg';
import incompleteAr from 'assets/icons/incomplete-icon_ar.svg';
import './Step.scss';
import { STATUS } from 'shared/constants';

const Step = ({
  isActive, status, number, title, description, intl, onButtonClick, isDisabled, currentLocale, customClass,
}) => {
  const stepClasses = classNames({
    'nw-step--active': isActive,
    'nw-step--completed': status === STATUS.COMPLETED,
    'nw-step--incompleted': status === STATUS.INCOMPLETE || (isActive && status === null),
  });

  const bottomButton = () => {
    switch (status) {
      case STATUS.INCOMPLETE:
        return (
          <Button
            value={intl.formatMessage({ id: 'journey.continue' })}
            isPrimary
            isBig
            onButtonClick={onButtonClick}
            isDisabled={isDisabled}
          />
        );
      case STATUS.COMPLETED:
        return (
          <Button
            value={(
              <Fragment>
                <FormattedMessage id="journey.viewEdit" />
                <img src={arrow} alt="Next" />
              </Fragment>
            )}
            isLink
            onButtonClick={onButtonClick}
            isDisabled={isDisabled}
          />
        );
      default:
        return (
          <Button
            value={intl.formatMessage({ id: 'journey.start' })}
            isPrimary
            isBig
            onButtonClick={onButtonClick}
            isDisabled={isDisabled}
          />
        );
    }
  };

  return (
    <div className={`nw-step ${stepClasses} ${customClass}`}>
      <FormattedMessage id="journey.step" values={{ number }} />
      <h2><FormattedMessage id={title} /></h2>
      {isActive && status === null && description && <p><FormattedMessage id={description} /></p>}
      {isActive && <Fragment>{bottomButton()}</Fragment>}
      {status === STATUS.COMPLETED && <img src={currentLocale !== 'AR' ? complete : completeAr} alt="Complete" />}
      {isActive && status === STATUS.INCOMPLETE && <img src={currentLocale !== 'AR' ? incomplete : incompleteAr} alt="Incomplete" />}
    </div>
  );
};

Step.propTypes = {
  // if step is active
  isActive: PropTypes.bool,
  // default, incomplete, complete
  status: PropTypes.string,
  /** button func */
  onButtonClick: PropTypes.func,
  /** disable step during redo another step */
  isDisabled: PropTypes.bool,
};

Step.defaultProps = {
  isActive: false,
  status: 'default',
  onButtonClick: () => {},
  isDisabled: false,
};

export default injectIntl(Step);
